import {List} from "../../@types/privacyPolicySectionResources.tsx";
import LegalPageSectionParagraphTransComponent
    from "../legal-pages-components/LegalPageSectionParagraphTransComponent.tsx";
import i18n from "i18next";
import {getCurrentLanguageEnum} from "../../@types/generics.tsx";

const LegalPageParagraphList = ({list, locale}: {list: List[], locale?: string}) => {

    const currentLanguage = getCurrentLanguageEnum(i18n.language);

    return (
        <>
            <ol>
                {list.map((listItem, index) => (
                    listItem.languageToShow.includes(currentLanguage)
                        && <li key={index} className="mb-4 mt-4 text-blue-dark">
                            <LegalPageSectionParagraphTransComponent text={listItem.text} locale={locale}/>
                            {listItem.subList && <ol>
                                {listItem.subList.map((subListItem, subIndex) => (
                                    subListItem.languageToShow.includes(currentLanguage)
                                        && <li key={subIndex} className="mb-4 mt-4 text-blue-dark">
                                            <LegalPageSectionParagraphTransComponent text={subListItem.text}
                                                                                 locale={locale}/>
                                        </li>
                                ))}
                            </ol>}
                            {listItem.newOrderSubList && <ol type="1">
                                {listItem.newOrderSubList.map((subListItem, subIndex) => (
                                    <li key={subIndex} className="mb-4 mt-4 text-blue-dark">
                                    <LegalPageSectionParagraphTransComponent text={subListItem.text}
                                                                                 locale={locale}/>
                                    </li>
                                ))}
                            </ol>}
                        </li>
                ))}
            </ol>
        </>
    )
}

export default LegalPageParagraphList;
